import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import EditExchangeReasonModal from '../../../../views/order/common/modal/EditExchangeReasonModal';
import { ORDER_ITEM_EXCHANGE_TYPE } from '../../../../constants/service/app/orderConstants';
import { orderActions } from '../../../../store/modules/order';
import withModal from '../../../../lib/hoc/withModal';

class EditExchangeReasonModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      /**
       *  교환 사유타입
       */
      reasonType: ORDER_ITEM_EXCHANGE_TYPE.ORDER_MISTAKE,
      /**
       *  교환 상세사유
       */
      reason: null,
    };
  }

  /**
   * 모달 닫기 || 데이터 초기화
   */
  closeModal = () => {
    const { toggleModal } = this.props;
    toggleModal({
      name: 'editExchangeReasonModal',
    });
  };

  /**
   * 데이터 변경
   */
  setData = (data) => {
    this.setState({
      [data.name]: data.value,
    });
  };

  /**
   * 교환 사유 수정하기
   */
  onSubmit = () => {
    const { form, data, editOrderExchangeReason } = this.props;
    const { reasonType, reason } = this.state;
    const { orderItemInfo } = data;

    form.validateFields((err) => {
      if (err) return;

      editOrderExchangeReason({
        orderItemId: orderItemInfo.orderItemId,
        reasonType,
        reason,
      });

      this.closeModal();
    });
  };

  render() {
    const { form, isOpen, data } = this.props;

    return (
      <EditExchangeReasonModal
        {...this.state}
        form={form}
        isOpen={isOpen}
        data={data}
        closeModal={this.closeModal}
        setData={this.setData}
        onSubmit={this.onSubmit}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.order.editExchangeReasonModal.isOpen,
    data: state.order.editExchangeReasonModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: orderActions.toggleModal,
  editOrderExchangeReason: orderActions.editOrderExchangeReason,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withModal()(Form.create({})(EditExchangeReasonModalContainer)));
